require('../config/config.js');
require('../src/not_supported.html');
require('../images/Loading_icon.gif');
require('../images/chrome.svg');
require('../images/safari.svg');
require('../images/edge.svg');
require('./nr-browser-monitoring.js');
require('./OpenSans.woff2');
require('../images/swr_notification_image.png');
require('../src/resetPassword.html');

//this is the version which has been put to the server.
var pubNubLocalVersion = '4.21.1';
let pubNubLocal = require('../config/pubnub.' + pubNubLocalVersion + '.min.js');

if (!window.PubNub) {
  console.error('Pubnub not initialized, picking it from local version:' + pubNubLocalVersion);
  window.PubNub = pubNubLocal;
}

window.hideUnfinishedItems = true;
var ConfigLoaded = setInterval(function () {
  //only import rest of the files, if and only if language file is loaded. if not the function will be kept calling unless the language file is loaded
  if (window.APP && window.APP.LANGUAGE && window.APP.EXTERNAL_LINKS) {
    require('./root.js');
    //we are good to remove the interval as language file has loaded
    clearInterval(ConfigLoaded);
  }
}, 50);

var fakeLocalStorage = function () {
  var fakeLocalStorage = {};
  var storage;

  // If Storage exists we modify it to write to our fakeLocalStorage object instead.
  // If Storage does not exist we create an empty object.
  if (window.Storage && window.localStorage) {
    storage = window.Storage.prototype;
  } else {
    // We don't bother implementing a fake Storage object
    window.localStorage = {};
    storage = window.localStorage;
  }

  // For older IE
  if (!window.location.origin) {
    window.location.origin =
      window.location.protocol +
      '//' +
      window.location.hostname +
      (window.location.port ? ':' + window.location.port : '');
  }

  var dispatchStorageEvent = function (key, newValue) {
    var oldValue = key == null ? null : storage.getItem(key); // `==` to match both null and undefined
    var url = location.href.substr(location.origin.length);
    var storageEvent = document.createEvent('StorageEvent'); // For IE, http://stackoverflow.com/a/25514935/1214183

    storageEvent.initStorageEvent('storage', false, false, key, oldValue, newValue, url, null);
    window.dispatchEvent(storageEvent);
  };

  storage.key = function (i) {
    var key = Object.keys(fakeLocalStorage)[i];
    return typeof key === 'string' ? key : null;
  };

  storage.getItem = function (key) {
    return typeof fakeLocalStorage[key] === 'string' ? fakeLocalStorage[key] : null;
  };

  storage.setItem = function (key, value) {
    dispatchStorageEvent(key, value);
    fakeLocalStorage[key] = String(value);
  };

  storage.removeItem = function (key) {
    dispatchStorageEvent(key, null);
    delete fakeLocalStorage[key];
  };

  storage.clear = function () {
    dispatchStorageEvent(null, null);
    fakeLocalStorage = {};
  };
};

// Example of how to use it
if (typeof window.localStorage === 'object') {
  // Safari will throw a fit if we try to use localStorage.setItem in private browsing mode.
  try {
    localStorage.setItem('localStorageTest', 1);
    localStorage.removeItem('localStorageTest');
  } catch (e) {
    fakeLocalStorage();
  }
} else {
  // Use fake localStorage for any browser that does not support it.
  fakeLocalStorage();
}
